module.exports = __webpack_public_path__ + "img/PP_Sword_0222.6f8c9123.png";